import { useIsDesktop } from "@hooks/useIsDesktop";
import chunk from "lodash/chunk";
import sortBy from "lodash/sortBy";
import { useMemo } from "react";
import { randomBetweenExcluding_highMemoryUsage } from "@utils/randomBetweenExcluding";
import { MediaItem } from "@components/shared/MediaItem";

export const FooterMediaGrid = ({
  mediaItems,
}: {
  mediaItems: Array<{
    url: string | null;
    contentType: string | null;
  } | null>;
}) => {
  const isDesktop = useIsDesktop();
  const itemsWithGridColumnStart = useMemo(() => {
    let lastEmptyIndex = -1;
    return chunk(mediaItems, isDesktop ? 3 : 1)
      .map((chunk) => {
        const indexedChunk = chunk.map((item, index) => ({
          item,
          gridColumnStart: index + 1,
        }));

        const emptyIndex = randomBetweenExcluding_highMemoryUsage(
          0,
          indexedChunk.length,
          // mobile allows repeat empty indices
          lastEmptyIndex
        );
        lastEmptyIndex = emptyIndex;

        if (emptyIndex < indexedChunk.length)
          indexedChunk[emptyIndex].gridColumnStart = isDesktop ? 4 : 2;

        return sortBy(indexedChunk, "gridColumnStart");
      })
      .flat();
  }, [isDesktop, mediaItems]);

  return (
    <ul className="grid grid-cols-2 dsk:grid-cols-4 gap-10 dsk:gap-28 dsk:px-12">
      {itemsWithGridColumnStart.map(({ item, gridColumnStart }, index) => {
        return (
          <li key={index} style={{ gridColumnStart }} className="aspect-square">
            <div className="w-full aspect-video rounded-lg overflow-hidden">
              <MediaItem item={item} width={500} className="size-full" />
            </div>
          </li>
        );
      })}
    </ul>
  );
};
